// extracted by mini-css-extract-plugin
module.exports = {"navbar":"styles_navbar__25Q1X","logoBold":"styles_logoBold__38_lC","logoThin":"styles_logoThin__2jiEd","btnMyTasks":"styles_btnMyTasks__2W-5z","badge":"styles_badge__G1nCW"};